import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'
import _ from 'lodash'

export default function ReconciliationItemBasicInfoComponent({
  handleInnerFormChange,
  selectedReconciliationItem,
  onClose,
  handleFormSubmit
}: any) {
  console.log('selectedReconciliationItem', selectedReconciliationItem)
  return (
    <>
      <div className="flex justify-center items-center w-[600px]">
        <div className="w-full max-w-lg p-2 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold mb-4 text-center">{  selectedReconciliationItem?.Id ? "Edit Reconciliation Item" : "Add New Reconciliation Item"}</h1>
          <div className="flex flex-col gap-4">          
          <InputContainer
                    label="Settlement Ref No"
                    name="settlement_ref_no"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliationItem.settlement_ref_no',
                      })
                    }}
                    type="text"
                    value={selectedReconciliationItem.settlement_ref_no}
                  />

                  <InputContainer
                    label="Payment Id"
                    name="payment_id"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliationItem.payment_id',

                      })
                    }}
                    type="text"
                    value={selectedReconciliationItem?.payment_id}
                  />                                
                  <InputContainer
                    label="Status"
                    name="status"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliationItem.status',

                      })
                    }}
                    type="text"
                    value={selectedReconciliationItem?.status}
                  />    
                  <InputContainer
                    label="Amount"
                    name="amount"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliationItem.amount',

                      })
                    }}
                    type="number"
                    value={selectedReconciliationItem?.amount}
                  />   
                  <InputContainer
                    label="Comission"
                    name="comission"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliationItem.comission',

                      })
                    }}
                    type="number"
                    value={selectedReconciliationItem?.comission}
                  /> 
                  <InputContainer
                    label="Withholding Amount"
                    name="withholding_amount"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliationItem.withholding_amount',

                      })
                    }}
                    type="number"
                    value={selectedReconciliationItem?.withholding_amount}
                  /> 
                  <InputContainer
                    label="TCS"
                    name="tcs"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliationItem.tcs',

                      })
                    }}
                    type="number"
                    value={selectedReconciliationItem?.tcs}
                  />   
                  <InputContainer
                    label="TDS"
                    name="tds"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliationItem.tds',

                      })
                    }}
                    type="number"
                    value={selectedReconciliationItem?.tds}
                  />                                                                               
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              type="button"
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
              onClick={handleFormSubmit}
              type="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

    </>
  )
}